module.exports = __webpack_public_path__ + "images/emoji/sandal.770186fde55c5304ea77.png";